export default __webpack_public_path__ + "static/media/OmnigenFullColour.ef49ea72.svg";